export function initSeeInAction() {
  const sections = document.querySelectorAll('.see-in-action[data-section-id]');
  
  sections.forEach(section => {
    const sectionId = section.dataset.sectionId;
    const swiperContainer = document.getElementById(`see-in-action-swiper-${sectionId}`);
    const videoItems = section.querySelectorAll('.see-in-action__video-item');
    const modal = document.getElementById(`see-in-action-modal-${sectionId}`);
    
    if (!swiperContainer || !modal || videoItems.length === 0) return;
    
    const modalVideo = modal.querySelector('.see-in-action__modal-video');
    const modalClose = modal.querySelector('.see-in-action__modal-close');
    const modalOverlay = modal.querySelector('.see-in-action__modal-overlay');
    
    // Initialize Swiper
    let swiper = null;
    if (typeof Swiper !== 'undefined') {
      swiper = new Swiper(swiperContainer, {
        slidesPerView: 1.5,
        spaceBetween: 16,
        loop: false,
        grabCursor: true,
        breakpoints: {
          768: {
            slidesPerView: 2,
            spaceBetween: 20,
          },
          1000: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          1300: {
            slidesPerView: 5,
            spaceBetween: 20,
          },
        },
      });
    }
    
    // Hover: play silently
    videoItems.forEach(item => {
      const video = item.querySelector('.see-in-action__video');
      const wrapper = item.querySelector('.see-in-action__video-wrapper');
      
      if (video && wrapper) {
        video.muted = true;
        
        const videoUrl = item.dataset.videoUrl;
        if (videoUrl) {
          const source = video.querySelector('source');
          if (source && source.src !== videoUrl) {
            source.src = videoUrl;
          }
        }
        
        video.load();
        
        let hoverTimeout;
        let isHovering = false;
        let hasStartedPlaying = false;
        
        function playVideo() {
          const hasSource = video.src || (video.currentSrc && video.currentSrc.length > 0);
          if (!hasSource) {
            return;
          }
          
          video.muted = true;
          
          const attemptPlay = () => {
            video.currentTime = 0;
            const playPromise = video.play();
            
            if (playPromise !== undefined) {
              playPromise
                .then(() => {
                  hasStartedPlaying = true;
                })
                .catch(e => {
                  // Silent fail
                });
            }
          };
          
          if (video.readyState >= 2) {
            attemptPlay();
          } else if (video.readyState >= 1) {
            attemptPlay();
          } else {
            const playWhenReady = () => {
              attemptPlay();
            };
            
            video.addEventListener('canplay', playWhenReady, { once: true });
            video.addEventListener('loadeddata', playWhenReady, { once: true });
          }
        }
        
        wrapper.addEventListener('mouseenter', () => {
          isHovering = true;
          clearTimeout(hoverTimeout);
          
          if (video.readyState >= 2) {
            playVideo();
          } else {
            hoverTimeout = setTimeout(() => {
              if (isHovering) {
                playVideo();
              }
            }, 100);
          }
        });
        
        wrapper.addEventListener('mouseleave', () => {
          isHovering = false;
          clearTimeout(hoverTimeout);
          if (hasStartedPlaying) {
            video.pause();
            video.currentTime = 0;
            hasStartedPlaying = false;
          }
        });
        
        video.addEventListener('canplay', () => {
          if (isHovering && !hasStartedPlaying) {
            playVideo();
          }
        });
        
        video.addEventListener('loadeddata', () => {
          if (isHovering && !hasStartedPlaying) {
            playVideo();
          }
        });
      }
    });
    
    // Click: open modal with sound
    videoItems.forEach(item => {
      const videoUrl = item.dataset.videoUrl;
      const wrapper = item.querySelector('.see-in-action__video-wrapper');
      const playButton = item.querySelector('.see-in-action__play-button');
      
      function openModal() {
        modalVideo.controls = true;
        modalVideo.muted = false;
        modalVideo.src = videoUrl;
        modal.classList.add('open');
        modalVideo.addEventListener('loadeddata', () => {
          modalVideo.play().catch(e => {
            // Silent fail
          });
        }, { once: true });
        modalVideo.load();
      }
      
      if (wrapper && videoUrl) {
        wrapper.addEventListener('click', (e) => {
          if (e.target.closest('.see-in-action__play-button')) {
            e.stopPropagation();
          }
          openModal();
        });
        
        if (playButton) {
          playButton.addEventListener('click', (e) => {
            e.stopPropagation();
            openModal();
          });
        }
      }
    });
    
    // Close modal
    function closeModal() {
      modal.classList.remove('open');
      modalVideo.pause();
      modalVideo.currentTime = 0;
      modalVideo.src = '';
      modalVideo.controls = true;
    }
    
    if (modalClose) {
      modalClose.addEventListener('click', closeModal);
    }
    
    if (modalOverlay) {
      modalOverlay.addEventListener('click', closeModal);
    }
    
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape' && modal.classList.contains('open')) {
        closeModal();
      }
    });
  });
}

